module.exports = __webpack_public_path__ + "img/stock1.94bffc42.png";